import './styles/style.css';
import React from 'react';
import { createRoot } from 'react-dom/client';

import Root from './components/Root';

const { container } = global;
container.style.display = null;

console.log('process.env.NODE_ENV: ' + process.env.NODE_ENV);

const render = () => {
    try {
        const root = createRoot(document.getElementById('container'));
        root.render(<Root />);
    }
    catch (e) {
        if (process.env.NODE_ENV !== 'production') {
            // TODO show an application error display
        }
        throw e;
    }
}

render();
